import { render } from "./SavedFilters.vue?vue&type=template&id=1086f36a"
import script from "./SavedFilters.vue?vue&type=script&lang=js"
export * from "./SavedFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__